export default __webpack_public_path__ + "static/media/ic_glp_custom.5bd7d0ce.svg";